const signinRequiredErrorCodes = [
	"signin_required",
	"login_required",
	"interaction_required",
	"consent_required"
];

export function getAuthenticationErrorDetail(error) {
	return error?.error || error?.message || error?.toString?.() || "Unknown authentication error";
}

export function isSigninRequiredError(error) {
	const detail = getAuthenticationErrorDetail(error).toLowerCase();

	return signinRequiredErrorCodes.some(errorCode => detail.includes(errorCode))
		|| detail.includes("sign-in required")
		|| detail.includes("signin required")
		|| detail.includes("no signed-in user")
		|| detail.includes("no signed in user");
}
